import React from 'react';
import mustache from 'mustache';
import ProductThumbnail, {
  imageWouldRenderEmpty,
} from '../../../ui/ProductThumbnail';
import {
  useAnalyticsPost,
  NarvarClickTypes,
  NarvarClickSubTypes,
  NarvarEventComponents,
  NarvarEventTypes,
} from '../../../../hooks/Analytics';
import { Item } from '../../../../../../__generated__/loma';
import styles from './ItemImage.module.css';

const renderOptions = { escape: (x: string): string => x };

interface ItemImageProps {
  item: Item;
  featureName?: string;
  urlTemplate?: string | null;
  imageUrlTemplate?: string | null;
}

const ItemImage = ({
  item,
  featureName,
  urlTemplate,
  imageUrlTemplate,
}: ItemImageProps) => {
  const logEvent = useAnalyticsPost();

  const url =
    mustache.render(urlTemplate || '', item, undefined, renderOptions) ||
    item.url;

  return (
    <li className={styles.itemImageListItem}>
      <ProductThumbnail
        productInfo={item}
        urlTemplate={urlTemplate}
        renderAsLink={!!urlTemplate}
        imageUrlTemplate={imageUrlTemplate}
        s={{
          width: '3.5rem',
          height: '3.5rem',
        }}
        onClick={(): void =>
          logEvent({
            clickCategory: NarvarClickSubTypes.SHIPMENTS,
            clickLinkDestinationUrl: url,
            clickLinkLabel: url,
            clickSubType: NarvarClickSubTypes.SHIPMENTS,
            clickType: NarvarClickTypes.OUTGOING,
            eventComponent: NarvarEventComponents.NTH_PACK_SHIPMENTS,
            eventFeature: NarvarEventComponents.NTH_PACK_SHIPMENTS,
            eventType: NarvarEventTypes.CLICK,
            feature: featureName,
            pageComponent: NarvarEventComponents.NTH_PACK_SHIPMENTS,
          })
        }
      />
    </li>
  );
};

export default ItemImage;
export { imageWouldRenderEmpty };
